"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var widgets_1 = require("@tableau/widgets");
var Localize_1 = require("../../../gen-src/Localize");
var WorkbookTemplateWidgetsStyles_1 = require("../../styles/WorkbookTemplateWidgetsStyles");
var ProjectPicker_1 = require("./ProjectPicker");
var SelectProjectDialogContent = /** @class */ (function (_super) {
    __extends(SelectProjectDialogContent, _super);
    function SelectProjectDialogContent(props) {
        var _this = _super.call(this, props) || this;
        _this.handleWorkbookNameChange = function (e) {
            _this.setState({ workbookName: e.target.value });
            _this.props.onNameChanged(e.target.value);
        };
        _this.state = { workbookName: props.initialWorkbookName };
        return _this;
    }
    SelectProjectDialogContent.prototype.render = function () {
        return (React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsProjectPickerStyles.ProjectPickerDialog },
            React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsProjectPickerStyles.inputFullWidth },
                React.createElement(widgets_1.TextFieldWidget, { label: Localize_1.Messages.SelectProjectNameLabel(), testId: 'workbookname-textfield', kind: 'outline', value: this.state.workbookName, onChange: this.handleWorkbookNameChange, className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsProjectPickerStyles.inputFullWidth, style: { width: '100%' } })),
            React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsProjectPickerStyles.projectSelector },
                React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsProjectPickerStyles.projectPicker }, Localize_1.Messages.SelectProjectProjectLabel()),
                React.createElement(ProjectPicker_1.ProjectPicker, { onProjectSelected: this.props.onProjectSelected, siteName: this.props.siteName }))));
    };
    return SelectProjectDialogContent;
}(React.Component));
exports.SelectProjectDialogContent = SelectProjectDialogContent;
var SelectProjectDialogWidget = /** @class */ (function (_super) {
    __extends(SelectProjectDialogWidget, _super);
    function SelectProjectDialogWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.projectId = '';
        _this.workbookName = '';
        _this.openTime = 0;
        _this.wrappedOnCloseRequest = function () {
            _this.props.JumpstartTelemetry.SelectProject.Dismiss(_this.getOpenDuration());
            _this.props.onCloseRequest();
        };
        _this.state = { invalidInput: true };
        _this.workbookName = _this.props.initialWorkbookName;
        _this.onProjectSelected = _this.onProjectSelected.bind(_this);
        _this.onWorkbookNameChange = _this.onWorkbookNameChange.bind(_this);
        _this.onDialogOk = _this.onDialogOk.bind(_this);
        return _this;
    }
    SelectProjectDialogWidget.prototype.componentDidMount = function () {
        this.openTime = Date.now();
        this.props.JumpstartTelemetry.SelectProject.Open();
    };
    /**
     * Should only be used after this.openTime is set.
     */
    SelectProjectDialogWidget.prototype.getOpenDuration = function () {
        var now = Date.now();
        var duration = now - this.openTime;
        return duration;
    };
    SelectProjectDialogWidget.prototype.onProjectSelected = function (projectId) {
        this.projectId = projectId;
        this.setState({ invalidInput: this.isInvalidInput() });
    };
    SelectProjectDialogWidget.prototype.onWorkbookNameChange = function (name) {
        this.workbookName = name;
        this.setState({ invalidInput: this.isInvalidInput() });
    };
    SelectProjectDialogWidget.prototype.isInvalidInput = function () {
        return this.projectId.length === 0 || this.workbookName.trim().length === 0;
    };
    SelectProjectDialogWidget.prototype.onDialogOk = function () {
        this.props.JumpstartTelemetry.SelectProject.Select(this.projectId, this.getOpenDuration());
        this.props.projectSelected(this.projectId, this.workbookName);
    };
    SelectProjectDialogWidget.prototype.BuildProps = function () {
        var dialogFooterButtonsProps = {
            buttons: [
                {
                    handleClick: this.wrappedOnCloseRequest,
                    buttonType: widgets_1.ButtonType.Outline,
                    children: Localize_1.Messages.SelectProjectCancel(),
                    testId: 'select-project-dialog-cancel',
                },
                {
                    handleClick: this.onDialogOk,
                    buttonType: widgets_1.ButtonType.Primary,
                    disabled: this.state.invalidInput,
                    children: Localize_1.Messages.SelectProjectOk(),
                    testId: 'select-project-dialog-ok',
                },
            ],
            testId: 'SelectProjectDialogFooter',
        };
        var dialogProps = {
            shouldReturnFocusOnClose: false,
            zIndex: 1031,
            dialogWidth: 350,
            dialogStyle: {
                maxWidth: 500,
            },
            type: widgets_1.DialogType.NormalWithTitleBar,
            title: Localize_1.Messages.SelectProjectTitle(),
            showCloseButton: true,
            positioningBehavior: widgets_1.DialogPositioningBehavior.Centered,
            isModal: true,
            testId: 'SelectProjectDialog',
            onCloseRequest: this.wrappedOnCloseRequest,
            showFooter: true,
            footerContent: React.createElement(widgets_1.DialogFooterButtonsWidget, __assign({}, dialogFooterButtonsProps)),
        };
        return dialogProps;
    };
    SelectProjectDialogWidget.prototype.render = function () {
        return (React.createElement(widgets_1.DialogWidget, __assign({}, this.BuildProps()),
            React.createElement(SelectProjectDialogContent, { initialWorkbookName: this.props.siteName, onProjectSelected: this.onProjectSelected, onNameChanged: this.onWorkbookNameChange, siteName: this.props.siteName })));
    };
    return SelectProjectDialogWidget;
}(React.Component));
exports.SelectProjectDialogWidget = SelectProjectDialogWidget;
//# sourceMappingURL=SelectProjectDialogWidget.js.map